module.exports = __webpack_public_path__ + "static/logo-atlassian-9bae38b6a062b1954244b55d78d6fe8e.png";